import { Bookmark, History } from 'lucide-react';
import { useVersionStore } from '../../stores/versionStore';

// Zwei Einträge im Menü des Berechnungs-Chips (AppHeader). Nur rendern,
// wenn Pro + Projekt + gespeicherte Berechnung (prüft der Aufrufer).
export default function VersionMenuItems({ onDone, disabled = false }) {
  const item = 'w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-ink-2 hover:bg-surface-2 rounded-md disabled:opacity-50';
  return (
    <div className="p-2 border-t border-line flex flex-col gap-0.5">
      <button
        type="button"
        role="menuitem"
        disabled={disabled}
        className={item}
        onClick={() => { useVersionStore.getState().openNameDialog(); onDone?.(); }}
      >
        <Bookmark size={13} aria-hidden="true" /> Stand benennen…
      </button>
      <button
        type="button"
        role="menuitem"
        className={item}
        onClick={() => { useVersionStore.getState().openPanel(); onDone?.(); }}
      >
        <History size={13} aria-hidden="true" /> Versionen…
      </button>
    </div>
  );
}
